/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { INotificationPreferences } from '../../components/notifications';
import { IAccountSettings, IReplayUserSettings, IUserFeatures, IUserPermissions, IUserSettings } from '../../models';

export interface IUserMapSettingsState {
  userName: string;
  accountId: number;
  accountSettings: IAccountSettings;
  features: IUserFeatures;
  notificationPreferences: INotificationPreferences[];
  permissions: IUserPermissions;
  universalAccountId: string;
  userRowGuid: string;
  userSettings: IUserSettings;
  webSocketAccountId: string;
  webSocketUserId: string;
  featureToggles: string[];
  replaySettings?: IReplayUserSettings;
  userType: string;
}

export const initialUserDataState: IUserMapSettingsState = {
  userName: null,
  accountId: null,
  accountSettings: null,
  features: null,
  notificationPreferences: [],
  permissions: null,
  universalAccountId: null,
  userRowGuid: null,
  userSettings: null,
  webSocketAccountId: null,
  webSocketUserId: null,
  featureToggles: [],
  replaySettings: null,
  userType: null
};
